import { InjectionToken, Injectable, Inject, Component, ViewChild, ViewContainerRef, ChangeDetectorRef, NgZone, SkipSelf, Optional, ElementRef, HostListener, EventEmitter, ViewEncapsulation, Output, Input, forwardRef, HostBinding, Pipe, ANALYZE_FOR_ENTRY_COMPONENTS, NgModule } from '@angular/core';
import { FormlyConfig, FieldWrapper, FormlyModule, FormlyForm } from '@ngx-formly/core';
import { __awaiter } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import { isString as isString$1 } from 'lodash';
import { BehaviorSubject, fromEvent, timer, NEVER, merge } from 'rxjs';
import { tap, catchError, map, debounceTime, switchMap } from 'rxjs/operators';
import { cloneDeep, get, set, unset } from 'lodash-es';
import { FormGroup, FormArray, FormBuilder, NG_VALUE_ACCESSOR, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import 'jquery';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-formly/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';

const _c0 = ["fieldComponent"];
function FormlyDesignerWrapperComponent_ng_template_0_Template(rf, ctx) { }
const _c1 = ["content"];
function FormlyDesignerFieldWrapperComponent_ng_template_2_Template(rf, ctx) { }
function FormlyDesignerFieldWrapperComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} }
function FormlyDesignerFieldWrapperComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} }
const _c2 = function (a0, a1, a2, a3, a4) { return { "designer-subject": a0, "designer-drag-source": a1, "designer-drop-hint": a2, "designer-drop-target": a3, "designer-hover": a4 }; };
const _c3 = ["formlyFormContainer"];
const _c4 = function () { return []; };
function FormlyDesignerComponent_formly_form_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "formly-form", 3);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    let tmp_3_0;
    ɵngcc0.ɵɵproperty("options", ctx_r0.options)("model", ctx_r0.model)("form", ctx_r0.form)("fields", (tmp_3_0 = ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r0.formlyDesignerService.designerFields$)) !== null && tmp_3_0 !== undefined ? tmp_3_0 : ɵngcc0.ɵɵpureFunction0(6, _c4));
} }
const _c5 = function (a0, a1) { return { "drop-hint": a0, "drop-target": a1 }; };
function FormlyDesignerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("dragenter", function FormlyDesignerComponent_ng_template_2_Template_div_dragenter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onDragEnter($event); })("dragleave", function FormlyDesignerComponent_ng_template_2_Template_div_dragleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onDragLeave(); })("dragover", function FormlyDesignerComponent_ng_template_2_Template_div_dragover_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onDragOver($event); })("drop", function FormlyDesignerComponent_ng_template_2_Template_div_drop_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onDrop($event); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtext(3, "+");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c5, ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r2.isDragging$), ctx_r2.dropTargetCounter > 0));
} }
const _c6 = ["block"];
function FieldEditorComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2, "className");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function FieldEditorComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2, "fieldGroupClassName");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function FieldEditorComponent_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, " type required. ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c7 = function (a0) { return { "has-danger": a0 }; };
function FieldEditorComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2, "type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "formly-designer-type-select", 14);
    ɵngcc0.ɵɵtemplate(4, FieldEditorComponent_div_9_div_4_Template, 2, 0, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c7, ctx_r2.form.hasError("type") && (ctx_r2.type.dirty || ctx_r2.type.touched)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldGroup", ctx_r2.fieldGroup)("type", ctx_r2.type.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.form.hasError("type") && (ctx_r2.type.dirty || ctx_r2.type.touched));
} }
function FieldEditorComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2, "wrappers");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "formly-designer-wrappers-picker", 17);
    ɵngcc0.ɵɵlistener("selected", function FieldEditorComponent_div_10_Template_formly_designer_wrappers_picker_selected_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onWrappersSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", ctx_r3.field);
} }
function FieldEditorComponent_formly_form_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "formly-form", 18);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("form", ctx_r5.fieldForm)("fields", ctx_r5.fields)("model", ctx_r5.field);
} }
const _c8 = function (a0) { return { solo: a0 }; };
const _c9 = ["*"];
const _c10 = ["modal"];
function TypeSelectComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", type_r1.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(type_r1.label);
} }
function TypesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("dragstart", function TypesComponent_div_0_Template_div_dragstart_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const type_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onDragStart($event, type_r1.value); })("dragend", function TypesComponent_div_0_Template_div_dragend_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onDragEnd(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", type_r1.label, " ");
} }
function WrapperSelectComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const wrapper_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", wrapper_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(wrapper_r1);
} }
const _c11 = "select[_ngcontent-%COMP%] {\n      width: 100%;\n    }";
function WrappersPickerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function WrappersPickerComponent_div_3_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.edit(i_r4); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 19);
    ɵngcc0.ɵɵlistener("click", function WrappersPickerComponent_div_3_Template_i_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.remove(i_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const wrapper_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", wrapper_r3, "\u00A0\u00A0");
} }
const FORMLY_DESIGNER_CONFIG_TOKEN = new InjectionToken('FORMLY_DESIGNER_CONFIG_TOKEN');
const DESIGNER_WRAPPER_NAME = '$designer';
const FIELD_DESIGNER_WRAPPER_NAME = '$fieldDesigner';
const DESIGNER_WRAPPER_TYPES = [
    DESIGNER_WRAPPER_NAME,
    FIELD_DESIGNER_WRAPPER_NAME,
];
class FormlyDesignerConfig {
    constructor(configs = [], formlyConfig) {
        this.formlyConfig = formlyConfig;
        this.types = {};
        this.wrappers = {};
        this.settings = { showClassName: true };
        configs.forEach(config => this.addConfig(config));
    }
    addConfig(config) {
        if (config.settings) {
            this.setSettings(config.settings);
        }
        if (config.types) {
            this.setType(config.types);
        }
        if (config.wrappers) {
            this.setWrapper(config.wrappers);
        }
    }
    setSettings(settings) {
        if (settings.showClassName !== undefined) {
            this.settings.showClassName = !!settings.showClassName;
        }
    }
    setType(options) {
        if (Array.isArray(options)) {
            options.forEach((option) => {
                this.setType(option);
            });
        }
        else {
            // Throw if type isn't part of the formly config
            this.formlyConfig.getType(options.name);
            if (!this.types[options.name]) {
                this.types[options.name] = {};
            }
            const type = this.types[options.name];
            type.name = options.name;
            type.fieldArray = !!options.fieldArray;
            type.fieldGroup = !!options.fieldGroup;
            type.fields = options.fields;
        }
    }
    setWrapper(options) {
        if (Array.isArray(options)) {
            options.forEach((option) => {
                this.setWrapper(option);
            });
        }
        else {
            // Throw if wrapper isn't part of the formly config
            this.formlyConfig.getWrapper(options.name);
            if (!this.wrappers[options.name]) {
                this.wrappers[options.name] = {};
            }
            const wrapper = this.wrappers[options.name];
            wrapper.name = options.name;
            wrapper.fields = options.fields;
        }
    }
}
FormlyDesignerConfig.ɵfac = function FormlyDesignerConfig_Factory(t) { return new (t || FormlyDesignerConfig)(ɵngcc0.ɵɵinject(FORMLY_DESIGNER_CONFIG_TOKEN), ɵngcc0.ɵɵinject(ɵngcc1.FormlyConfig)); };
FormlyDesignerConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormlyDesignerConfig, factory: FormlyDesignerConfig.ɵfac });
FormlyDesignerConfig.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [FORMLY_DESIGNER_CONFIG_TOKEN,] }] },
    { type: FormlyConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerConfig, [{
        type: Injectable
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [FORMLY_DESIGNER_CONFIG_TOKEN]
            }] }, { type: ɵngcc1.FormlyConfig }]; }, null); })();

/** Creates a wrapper sandwich to augment the form */
class DesignerExtension {
    postPopulate(field) {
        var _a;
        // Only surround non-editor fields; assumes editor fields have no $designerId
        if ((_a = field === null || field === void 0 ? void 0 : field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId) {
            field.wrappers = [FIELD_DESIGNER_WRAPPER_NAME, ...(field.wrappers || []), DESIGNER_WRAPPER_NAME];
        }
    }
}
DesignerExtension.ɵfac = function DesignerExtension_Factory(t) { return new (t || DesignerExtension)(); };
DesignerExtension.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DesignerExtension, factory: DesignerExtension.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesignerExtension, [{
        type: Injectable
    }], null, null); })();

class FormlyDesignerWrapperComponent extends FieldWrapper {
}
FormlyDesignerWrapperComponent.ɵfac = /*@__PURE__*/ function () { let ɵFormlyDesignerWrapperComponent_BaseFactory; return function FormlyDesignerWrapperComponent_Factory(t) { return (ɵFormlyDesignerWrapperComponent_BaseFactory || (ɵFormlyDesignerWrapperComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyDesignerWrapperComponent)))(t || FormlyDesignerWrapperComponent); }; }();
FormlyDesignerWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyDesignerWrapperComponent, selectors: [["formly-designer-wrapper"]], viewQuery: function FormlyDesignerWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [["fieldComponent", ""]], template: function FormlyDesignerWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormlyDesignerWrapperComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2 });
FormlyDesignerWrapperComponent.propDecorators = {
    fieldComponent: [{ type: ViewChild, args: ['fieldComponent', { read: ViewContainerRef, static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-wrapper',
                template: `
    <ng-template #fieldComponent></ng-template>
  `
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef, static: true }]
        }] }); })();

class DragDropService {
    constructor() {
        this._dragging = new BehaviorSubject(null);
        this._dropTarget = new BehaviorSubject(null);
    }
    get dragging() { return this._dragging.value; }
    get dragging$() {
        return this._dragging.asObservable();
    }
    get dropTarget() { return this._dropTarget.value; }
    set dropTarget(id) {
        this._dropTarget.next(id);
    }
    get dropTarget$() {
        return this._dropTarget.asObservable();
    }
    beginDrag(subject) {
        if (subject == null) {
            return;
        }
        console.assert(this._dragging.value === null);
        this._dragging.next(subject);
    }
    endDrag() {
        if (this._dragging.value != null) {
            this._dragging.next(null);
        }
    }
}
DragDropService.ɵfac = function DragDropService_Factory(t) { return new (t || DragDropService)(); };
DragDropService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DragDropService, factory: DragDropService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragDropService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const keyPathMemberName = '_formlyDesignerKeyPath';
// Source: https://github.com/formly-js/ngx-formly/blob/master/src/core/src/lib/utils.ts
function getKeyPath(field) {
    /* We store the keyPath in the field for performance reasons. This function will be called frequently. */
    if (!field[keyPathMemberName] || field[keyPathMemberName].key !== field.key) {
        let keyPath = [];
        if (field.key) {
            /* Also allow for an array key, hence the type check  */
            const pathElements = isArray(field.key) ? field.key : field.key.toString().split('.');
            for (let pathElement of pathElements) {
                if (typeof pathElement === 'string') {
                    /* replace paths of the form names[2] by names.2, cfr. angular formly */
                    pathElement = pathElement.replace(/\[(\w+)\]/g, '.$1');
                    keyPath = keyPath.concat(pathElement.split('.'));
                }
                else {
                    keyPath.push(pathElement);
                }
            }
            for (let i = 0; i < keyPath.length; i++) {
                const pathElement = keyPath[i];
                if (typeof pathElement === 'string' && /^\d+$/.test(pathElement)) {
                    keyPath[i] = parseInt(pathElement, 10);
                }
            }
        }
        field[keyPathMemberName] = {
            key: field.key,
            path: keyPath,
        };
    }
    return field[keyPathMemberName].path.slice();
}
function equalType(a, b) {
    return (!a.fieldArray === !b.fieldArray) && (!a.fieldGroup === !b.fieldGroup);
}
const isArray = Array.isArray;
// https://stackoverflow.com/a/28953167
const isEmpty = (val) => {
    if (val == null) {
        return true;
    }
    else if (typeof val === 'function' || typeof val === 'number' || typeof val === 'boolean' ||
        Object.prototype.toString.call(val) === '[object Date]') {
        return false;
    }
    else if (val.length === 0) { // 0 length array or string
        return true;
    }
    else if (typeof val === 'object') {
        // empty object
        let r = true;
        for (const _ in val)
            r = false;
        return r;
    }
    return false;
};
const isFunction = (val) => typeof val === 'function';
const isObject = (val) => val != null && typeof val === 'object';
const isString = (val) => typeof val === 'string' || val instanceof String;
/** Source:  https://stackoverflow.com/a/8809472 */
const generateUuid = () => {
    let d = new Date().getTime();
    let d2 = ((performance === null || performance === void 0 ? void 0 : performance.now) && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        }
        else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
};

class FieldsService {
    constructor(formlyDesignerConfig) {
        this.formlyDesignerConfig = formlyDesignerConfig;
    }
    getFullKeyPath(field, fields) {
        let keyPath = [];
        if (field && field.key) {
            const parents = new Map();
            this.traverseFields(fields, (f, path, parent) => {
                parent && parents.set(f, parent);
            });
            keyPath = getKeyPath(field);
            let cur = parents.get(field);
            while (cur) {
                keyPath = getKeyPath(cur).concat(keyPath);
                cur = parents.get(cur);
            }
        }
        return keyPath;
    }
    getTypeFields(type) {
        return this.getFields(type, 'type');
    }
    getWrapperFields(wrapper) {
        return wrapper ? this.getFields(wrapper, 'wrapper') : [];
    }
    checkField(field, fields, parent) {
        if (field.key == null || (isString(field.key) && !field.key) || (isArray(field.key) && !field.key.length)) {
            return true;
        }
        const fullPathByField = new Map();
        const newPath = this.getFullKeyPath(parent || {}, fields).concat(getKeyPath(field));
        const length = newPath.length;
        return !this.traverseFields(fields, (f, p) => {
            const path = fullPathByField.get(f) || fullPathByField.set(f, (p || []).concat(getKeyPath(f))).get(f);
            if ((path === null || path === void 0 ? void 0 : path.length) !== length) {
                return;
            }
            for (let i = 0; i < length; i++) {
                if (path[i] !== newPath[i]) {
                    return;
                }
            }
            return !equalType(field, f);
        });
    }
    find(id, fields) {
        var _a;
        if (!id || !isArray(fields)) {
            return;
        }
        const stack = fields.slice();
        while (stack.length) {
            const field = stack.pop();
            if (((_a = field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId) === id) {
                return field;
            }
            if (field.fieldArray) {
                stack.push(field.fieldArray);
            }
            else if (field.fieldGroup) {
                stack.push(...field.fieldGroup);
            }
        }
        return;
    }
    /** Find a field by full key path  */
    findField(field, fields, parent) {
        if (!field || !fields) {
            return;
        }
        const fullPathByField = new Map();
        const newPath = this.getFullKeyPath(parent || {}, fields).concat(getKeyPath(field));
        const length = newPath.length;
        return this.traverseFields(fields, (f, p) => {
            const path = fullPathByField.get(f) || fullPathByField.set(f, (p || []).concat(getKeyPath(f))).get(f);
            if ((path === null || path === void 0 ? void 0 : path.length) !== length) {
                return;
            }
            for (let i = 0; i < length; i++) {
                if (path[i] === newPath[i]) {
                    return f;
                }
            }
            return;
        });
    }
    mutateField(field, editorField) {
        field.templateOptions = Object.assign({}, field.templateOptions);
        if (!editorField && !field.templateOptions.$designerId) {
            field.templateOptions.$designerId = generateUuid();
        }
        if (field.fieldGroup) {
            this.mutateFields(field.fieldGroup, editorField);
        }
        else if (field.fieldArray && field.fieldArray.fieldGroup) {
            if (editorField) {
                this.mutateField(field.fieldArray, editorField);
            }
            else {
                // Treating fieldArrays as fieldGroups
                field.templateOptions.$fieldArray = { type: field.type };
                field.fieldGroup = field.fieldArray.fieldGroup;
                delete field.fieldArray;
                delete field.type;
                this.mutateFields(field.fieldGroup, editorField);
            }
        }
        return field;
    }
    mutateFields(fields, editorFields) {
        fields.forEach(field => this.mutateField(field, editorFields));
    }
    traverseFields(fields, callback, path, parent) {
        path = path || [];
        for (const field of fields) {
            const value = callback(field, path, parent);
            if (value) {
                return value;
            }
            if (field.fieldArray) {
                const arrayValue = this.traverseFields([field.fieldArray], callback, path.concat(getKeyPath(field)), field);
                if (arrayValue) {
                    return arrayValue;
                }
            }
            else if (field.fieldGroup) {
                const groupValue = this.traverseFields(field.fieldGroup, callback, path.concat(getKeyPath(field)), field);
                if (groupValue) {
                    return groupValue;
                }
            }
        }
    }
    getFields(name, type) {
        var _a;
        const fields = (_a = this.getDesignerOptions(type)[name]) === null || _a === void 0 ? void 0 : _a.fields;
        if (!fields) {
            return [];
        }
        this.mutateFields(cloneDeep(fields), true);
        return fields;
    }
    getDesignerOptions(type) {
        if (type === 'type') {
            return this.formlyDesignerConfig.types;
        }
        if (type === 'wrapper') {
            return this.formlyDesignerConfig.wrappers;
        }
        return {};
    }
}
FieldsService.ɵfac = function FieldsService_Factory(t) { return new (t || FieldsService)(ɵngcc0.ɵɵinject(FormlyDesignerConfig)); };
FieldsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FieldsService, factory: FieldsService.ɵfac });
FieldsService.ctorParameters = () => [
    { type: FormlyDesignerConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldsService, [{
        type: Injectable
    }], function () { return [{ type: FormlyDesignerConfig }]; }, null); })();

var FieldType;
(function (FieldType) {
    FieldType[FieldType["Plain"] = 0] = "Plain";
    FieldType[FieldType["Designer"] = 1] = "Designer";
})(FieldType || (FieldType = {}));
class FormlyDesignerService {
    constructor(designerConfig, fieldsService, formlyConfig) {
        this.designerConfig = designerConfig;
        this.fieldsService = fieldsService;
        this.formlyConfig = formlyConfig;
        this._disabled = new BehaviorSubject(false);
        this._designerFields = new BehaviorSubject([]);
        this._fields = new BehaviorSubject([]);
        this._selectedField = new BehaviorSubject(null);
        this._model = new BehaviorSubject({});
    }
    get disabled() {
        return this._disabled.value;
    }
    set disabled(value) {
        this._disabled.next(!!value);
    }
    get disabled$() {
        return this._disabled.asObservable();
    }
    get selectedField$() {
        return this._selectedField.asObservable();
    }
    get selectedDesignerId() {
        var _a, _b;
        return (_b = (_a = this._selectedField.getValue()) === null || _a === void 0 ? void 0 : _a.templateOptions) === null || _b === void 0 ? void 0 : _b.$designerId;
    }
    get designerFields() {
        return this._designerFields.value;
    }
    set designerFields(value) {
        // Prune the fields because ngx-formly pollutes them with internal state
        // causing incorrect behavior when re-applied.
        const fields = isArray(value) ? cloneDeep(value) : [];
        const designerFields = this.createPrunedFields(fields, FieldType.Designer);
        this._designerFields.next(designerFields);
        this._fields.next(this.createPrunedFields(cloneDeep(designerFields), FieldType.Plain));
    }
    get designerFields$() {
        return this._designerFields.asObservable();
    }
    get fields() {
        return this._fields.value;
    }
    set fields(value) {
        // Prune the fields because ngx-formly pollutes them with internal state
        // causing incorrect behavior when re-applied.
        const fields = cloneDeep(value);
        const designerFields = this.createPrunedFields(fields, FieldType.Designer);
        this.fieldsService.mutateFields(designerFields, false);
        this._selectedField.next(null);
        this._designerFields.next(designerFields);
        this._fields.next(this.createPrunedFields(cloneDeep(designerFields), FieldType.Plain));
    }
    get fields$() {
        return this._fields.asObservable();
    }
    get model() {
        return this._model.value;
    }
    set model(value) {
        this._model.next(value == null ? {} : value);
    }
    get model$() {
        return this._model.asObservable();
    }
    addField(field, index) {
        this.fieldsService.mutateField(field, false);
        const fields = cloneDeep(this.designerFields);
        const fieldIndex = (index == null || isNaN(index)) ? this.fields.length :
            Math.min(this.fields.length, Math.max(0, index));
        fields.splice(fieldIndex, 0, field);
        this.updateFields(fields);
    }
    createField(type) {
        const field = {};
        if (type !== 'formly-group') {
            field.type = type;
        }
        const designerType = this.designerConfig.types[type];
        if (designerType === null || designerType === void 0 ? void 0 : designerType.fieldArray) {
            field.fieldArray = { fieldGroup: [] };
        }
        if (type === 'formly-group' || (designerType === null || designerType === void 0 ? void 0 : designerType.fieldGroup)) {
            field.fieldGroup = [];
        }
        return field;
    }
    didClickField(value) {
        this._selectedField.next(value);
    }
    removeField(field) {
        var _a;
        this.unsetField(field);
        const designerId = (_a = field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId;
        if (this.replaceField(designerId, null, this.designerFields)) {
            this.removeControl(field.formControl);
        }
        this.updateFields();
    }
    updateField(original, modified) {
        var _a;
        const pruned = this.fieldsService.mutateField(this.createPrunedField(modified), false);
        const designerId = (_a = original === null || original === void 0 ? void 0 : original.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId;
        if (this.replaceField(designerId, pruned, this.designerFields)) {
            if (original && original.formControl !== pruned.formControl) {
                this.unsetField(original);
                this.removeControl(original.formControl);
            }
            this.updateFields();
        }
    }
    getWrappers(field) {
        var _a;
        if (!field || !isArray(field.wrappers)) {
            return [];
        }
        const clonedField = cloneDeep(field);
        let wrappers = clonedField.wrappers = (clonedField.wrappers || []);
        const filterWrapper = (_a = this.designerConfig.settings.filterWrapper) !== null && _a !== void 0 ? _a : ((wrapper, _) => wrapper !== 'form-field');
        if (filterWrapper && isFunction(filterWrapper)) {
            wrappers = wrappers.filter(w => filterWrapper(w, clonedField));
        }
        // Determine wrappers part of the formly configuration (static and dynamic) to exclude them from the result
        const staticWrappers = (field.type && this.formlyConfig.getType(field.type).wrappers) || [];
        const typeWrappers = staticWrappers
            .concat(this.formlyConfig.templateManipulators.preWrapper.map(m => m(clonedField)))
            .concat(this.formlyConfig.templateManipulators.postWrapper.map(m => m(clonedField)))
            .concat(DESIGNER_WRAPPER_TYPES);
        // Remove wrappers part of the formly configuration from the result
        if (typeWrappers.length > 0) {
            for (let i = wrappers.length - 1; i >= 0; i--) {
                for (let j = typeWrappers.length - 1; j >= 0; j--) {
                    if (wrappers[i] === typeWrappers[j]) {
                        typeWrappers.splice(j, 1);
                        wrappers.splice(i, 1);
                        break;
                    }
                }
            }
        }
        return wrappers;
    }
    /** Prunes field of unrecognized properties */
    createPrunedField(field, fieldType = FieldType.Designer) {
        var _a;
        const designerType = this.getDesignerType(field);
        const pruned = isEmpty(field.key) ? {} : { key: field.key };
        if (designerType) {
            pruned.type = designerType.name;
            if (fieldType === FieldType.Designer && ((_a = field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId)) {
                pruned.templateOptions = { $designerId: field.templateOptions.$designerId };
            }
            this.applyProperties(field, pruned, designerType.fields);
            if (designerType.fieldArray) {
                pruned.fieldArray = {
                    fieldGroup: this.createPrunedFields(field.fieldGroup, fieldType)
                };
            }
        }
        if (isArray(field.fieldGroup) && !isArray(pruned.fieldArray)) {
            pruned.fieldGroup = this.createPrunedFields(field.fieldGroup, fieldType);
            let fieldGroupClassName;
            if (isString(field.fieldGroupClassName) &&
                (fieldGroupClassName = field.fieldGroupClassName.trim()).length > 0) {
                pruned.fieldGroupClassName = fieldGroupClassName;
            }
        }
        let className;
        if (isString(field.className) && (className = field.className.trim()).length > 0) {
            pruned.className = className;
        }
        const wrappers = this.getWrappers(field);
        if (wrappers.length > 0) {
            pruned.wrappers = wrappers;
            const designerWrapperFields = wrappers.map(wrapper => this.designerConfig.wrappers[wrapper])
                .filter(designerOption => designerOption && isArray(designerOption.fields))
                .reduce((previous, current) => previous.concat(current.fields || []), []);
            this.applyProperties(field, pruned, designerWrapperFields);
        }
        return pruned;
    }
    /** Prunes fields of unrecognized properties */
    createPrunedFields(fields, fieldType = FieldType.Designer) {
        const prunedFields = [];
        if (isArray(fields)) {
            fields.forEach(field => {
                const pruned = this.createPrunedField(field, fieldType);
                if (field.fieldArray) {
                    pruned.fieldArray = this.createPrunedField(field.fieldArray, fieldType);
                }
                else if (field.fieldGroup && !pruned.fieldArray) {
                    pruned.fieldGroup = this.createPrunedFields(field.fieldGroup, fieldType);
                }
                if (Object.keys(pruned).length > 0) {
                    prunedFields.push(pruned);
                }
            });
        }
        return prunedFields;
    }
    getTypeName(type) {
        if (type === 'formly-group') {
            return 'fieldGroup';
        }
        return type !== null && type !== void 0 ? type : '';
    }
    applyProperties(field, designed, designerFields) {
        if (isArray(designerFields)) {
            designerFields.forEach(designerField => {
                const key = designerField.key;
                if (key == null) {
                    return;
                }
                const value = get(field, key);
                if (value != null && (!isString(value) || value.length > 0) && value !== designerField.defaultValue) {
                    set(designed, key, value);
                }
            });
        }
    }
    getDesignerType(field) {
        var _a, _b, _c;
        const type = (_c = (_b = (_a = field === null || field === void 0 ? void 0 : field.templateOptions) === null || _a === void 0 ? void 0 : _a.$fieldArray) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : field.type;
        const designerType = this.designerConfig.types[type];
        if (designerType) {
            return designerType;
        }
        if (field.type === 'formly-group' || (!field.type && isArray(field.fieldGroup))) {
            return { name: field.type, fieldGroup: true, fields: [] };
        }
        return;
    }
    replaceField(id, field, fields) {
        var _a;
        if (!id || !isArray(fields)) {
            return false;
        }
        for (let i = 0, l = fields.length; i < l; i++) {
            const otherField = fields[i];
            if (((_a = otherField.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId) === id) {
                if (field == null) {
                    fields.splice(i, 1);
                }
                else {
                    fields[i] = field;
                }
                return true;
            }
            if (otherField.fieldGroup && this.replaceField(id, field, otherField.fieldGroup)) {
                return true;
            }
            if (otherField.fieldArray && this.replaceFieldArray(id, field, otherField)) {
                return true;
            }
        }
        return false;
    }
    replaceFieldArray(id, field, parent) {
        var _a;
        if (!id) {
            return false;
        }
        const fieldArray = parent.fieldArray;
        if (!fieldArray) {
            return false;
        }
        if (((_a = fieldArray.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId) === id) {
            if (field) {
                parent.fieldArray = field;
                return true;
            }
            return false;
        }
        if (fieldArray.fieldGroup && this.replaceField(id, field, fieldArray.fieldGroup)) {
            return true;
        }
        return fieldArray.fieldArray != null && this.replaceFieldArray(id, field, fieldArray);
    }
    buildPath(key, path, arrayNext = false) {
        return path ? key + (arrayNext ? path : '.' + path) : key;
    }
    path(control, includeSelf = true) {
        let path = '';
        let arrayNext = false;
        let root = includeSelf ? control : control === null || control === void 0 ? void 0 : control.parent;
        for (let child = root, parent = root === null || root === void 0 ? void 0 : root.parent; !!parent; child = parent, parent = parent.parent) {
            if (parent instanceof FormGroup) {
                for (const key in parent.controls) {
                    if (parent.controls[key] === child) {
                        path = this.buildPath(key, path, arrayNext);
                        arrayNext = false;
                        break;
                    }
                }
            }
            else if (parent instanceof FormArray) {
                for (let i = 0; i < parent.length; i++) {
                    if (parent.at(i) === child) {
                        path = this.buildPath('[' + i + ']', path, arrayNext);
                        arrayNext = true;
                        break;
                    }
                }
            }
        }
        return path;
    }
    unsetField(field) {
        if (field.fieldArray) {
            this.unsetField(field.fieldArray);
        }
        if (field.fieldGroup) {
            field.fieldGroup.forEach(f => this.unsetField(f));
        }
        if (field.formControl) {
            const path = this.path(field.formControl);
            unset(this.model, path);
        }
    }
    removeControl(control) {
        const parent = control === null || control === void 0 ? void 0 : control.parent;
        if (parent instanceof FormGroup) {
            for (const key in parent.controls) {
                if (parent.controls[key] === control) {
                    parent.removeControl(key);
                    return;
                }
            }
        }
        else if (parent instanceof FormArray) {
            for (let i = 0; i < parent.length; i++) {
                if (parent.at(i) === control) {
                    parent.removeAt(i);
                    return;
                }
            }
        }
    }
    updateFields(fields, model) {
        var _a;
        this.designerFields = fields !== null && fields !== void 0 ? fields : cloneDeep(this.designerFields);
        // Update the selected field to use the updated instance, if any
        this._selectedField.next((_a = this.fieldsService.find(this.selectedDesignerId, this.designerFields)) !== null && _a !== void 0 ? _a : null);
        this.model = model !== null && model !== void 0 ? model : cloneDeep(this.model);
    }
}
FormlyDesignerService.ɵfac = function FormlyDesignerService_Factory(t) { return new (t || FormlyDesignerService)(ɵngcc0.ɵɵinject(FormlyDesignerConfig), ɵngcc0.ɵɵinject(FieldsService), ɵngcc0.ɵɵinject(ɵngcc1.FormlyConfig)); };
FormlyDesignerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormlyDesignerService, factory: FormlyDesignerService.ɵfac });
FormlyDesignerService.ctorParameters = () => [
    { type: FormlyDesignerConfig },
    { type: FieldsService },
    { type: FormlyConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerService, [{
        type: Injectable
    }], function () { return [{ type: FormlyDesignerConfig }, { type: FieldsService }, { type: ɵngcc1.FormlyConfig }]; }, null); })();

var DragDropType;
(function (DragDropType) {
    DragDropType["Type"] = "formly-designer-type";
    DragDropType["Field"] = "formly-designer-field";
})(DragDropType || (DragDropType = {}));

class ParentService {
    constructor() {
        this._children = [];
    }
    get children() { return this._children; }
    set children(value) {
        this._children = value;
    }
    addChild(child, index) {
        const childIndex = index == null || isNaN(index) ? this.children.length :
            Math.min(this.children.length, Math.max(0, index));
        const children = this.children.slice();
        children.splice(childIndex, 0, child);
        this.children = children;
    }
    removeChild(child) {
        this.children = this.children.filter(c => c === child);
    }
    clearChildren() {
        this.children = [];
    }
}
ParentService.ɵfac = function ParentService_Factory(t) { return new (t || ParentService)(); };
ParentService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ParentService, factory: ParentService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ParentService, [{
        type: Injectable
    }], function () { return []; }, null); })();

var DropPlacement;
(function (DropPlacement) {
    DropPlacement[DropPlacement["self"] = 0] = "self";
    DropPlacement[DropPlacement["before"] = 1] = "before";
    DropPlacement[DropPlacement["after"] = 2] = "after";
})(DropPlacement || (DropPlacement = {}));
class FormlyDesignerFieldWrapperComponent extends FieldWrapper {
    constructor(changeDetector, dragDropService, fieldsService, formlyDesignerService, zone, parentService, document, parentParentService) {
        super();
        this.changeDetector = changeDetector;
        this.dragDropService = dragDropService;
        this.fieldsService = fieldsService;
        this.formlyDesignerService = formlyDesignerService;
        this.zone = zone;
        this.document = document;
        this.parentParentService = parentParentService;
        this.dropTargetCounter = 0;
        this.subscriptions = [];
        this._title = null;
        this._isDragging = false;
        this._isHovering = false;
        this._dropTargetPlacement = null;
        parentService.parent = this;
        if (parentParentService) {
            parentParentService.addChild(this);
        }
    }
    get title() { return this._title; }
    set title(value) {
        if (value !== this._title) {
            this._title = value;
            this.changeDetector.markForCheck();
        }
    }
    get isDragging() { return this._isDragging; }
    set isDragging(value) {
        if (value !== this._isDragging) {
            this._isDragging = value;
            this.changeDetector.markForCheck();
        }
    }
    get isHovering() { return this._isHovering; }
    set isHovering(value) {
        if (value !== this._isHovering) {
            this._isHovering = value;
            this.changeDetector.markForCheck();
        }
    }
    get parent() { var _a; return (_a = this.parentParentService) === null || _a === void 0 ? void 0 : _a.parent; }
    get dropTargetPlacement() { return this._dropTargetPlacement; }
    set dropTargetPlacement(value) {
        if (value !== this._dropTargetPlacement) {
            this._dropTargetPlacement = value;
            this.changeDetector.markForCheck();
        }
    }
    get designerId() { var _a; return (_a = this.field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId; }
    get isFieldGroup() { return Array.isArray(this.field.fieldGroup); }
    get isDragSource() {
        return this.dragDropService.dragging === this.designerId;
    }
    get isDropTarget() {
        return this.dragDropService.dropTarget === this.designerId;
    }
    get isDropTargetSelf() {
        return this.isDropTarget && !this.dropTargetPlacement && this.isFieldGroup;
    }
    get isDropTargetBefore() {
        return this.isDropTarget && this.dropTargetPlacement === DropPlacement.before;
    }
    get isDropTargetAfter() {
        return this.isDropTarget && this.dropTargetPlacement === DropPlacement.after;
    }
    get isSubject() {
        return this.formlyDesignerService.selectedDesignerId === this.designerId;
    }
    ngOnInit() {
        var _a, _b;
        if (!((_a = this.document) === null || _a === void 0 ? void 0 : _a.defaultView)) {
            return;
        }
        const content = (_b = this.content) === null || _b === void 0 ? void 0 : _b.nativeElement;
        if (!content) {
            return;
        }
        this.subscriptions.push(this.dragDropService.dragging$.subscribe(dragging => this.isDragging = dragging != null), fromEvent(this.document.defaultView, 'mouseup').subscribe(this.onWindowMouseUp.bind(this)));
        this.zone.runOutsideAngular(() => {
            this.subscriptions.push(fromEvent(content, 'dragover').subscribe(e => this.onDragOver(e)), fromEvent(content, 'mouseover').subscribe(e => this.onMouseOver(e)));
        });
    }
    ngOnDestroy() {
        var _a;
        this.subscriptions.splice(0).forEach(subscription => subscription.unsubscribe());
        (_a = this.parentParentService) === null || _a === void 0 ? void 0 : _a.removeChild(this);
    }
    onClick(event) {
        event.stopPropagation();
        this.formlyDesignerService.didClickField(this.field);
    }
    onDragStart(event) {
        var _a, _b, _c;
        if (this.dragDropService.dragging) {
            return;
        }
        (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData(DragDropType.Field, (_b = this.designerId) !== null && _b !== void 0 ? _b : '');
        this.dragDropService.beginDrag((_c = this.designerId) !== null && _c !== void 0 ? _c : null);
    }
    onDragEnd() {
        this.dragDropService.endDrag();
    }
    onDragEnter(event) {
        if (!this.shouldHandleDragEvent(event)) {
            return;
        }
        event.preventDefault();
        this.dropTargetCounter++;
    }
    onDragLeave(event) {
        if (!this.shouldHandleDragEvent(event)) {
            return;
        }
        if (this.dropTargetCounter > 0) {
            this.dropTargetCounter--;
            if (this.dropTargetCounter === 0) {
                this.dropTargetPlacement = null;
            }
        }
    }
    onDragOver(event) {
        if (event.defaultPrevented || !this.shouldHandleDragEvent(event)) {
            return;
        }
        this.zone.run(() => {
            var _a, _b;
            this.dropTargetPlacement = this.getDropTargetPlacement(event);
            this.dragDropService.dropTarget = (_b = (_a = this.field.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId) !== null && _b !== void 0 ? _b : null;
        });
        event.preventDefault();
    }
    shouldHandleDragEvent(event) {
        var _a, _b;
        if ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.some(t => t === DragDropType.Field)) {
            return this.dragDropService.dragging !== this.designerId;
        }
        return !!((_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.types.some(t => t === DragDropType.Type)) &&
            isString$1(this.dragDropService.dragging);
    }
    getDropTargetPlacement(event) {
        var _a;
        const rect = (_a = this.content) === null || _a === void 0 ? void 0 : _a.nativeElement.getBoundingClientRect();
        if (rect) {
            const threshold = rect.height * .33;
            if (event.clientY < rect.top + threshold) {
                return DropPlacement.before;
            }
            if (event.clientY > rect.bottom - threshold) {
                return DropPlacement.after;
            }
        }
        return DropPlacement.self;
    }
    onDrop(event) {
        var _a, _b;
        if (this.shouldHandleDragEvent(event)) {
            event.stopPropagation();
            if ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes(DragDropType.Field)) {
                const designerId = this.dragDropService.dragging;
                const field = this.fieldsService.find(designerId, this.formlyDesignerService.designerFields);
                if (field) {
                    // Get placement index before the fields refresh caused by removal
                    const index = this.getDropPlacementIndex(field);
                    this.formlyDesignerService.removeField(field);
                    if (this.parent && this.dropTargetPlacement !== DropPlacement.self) {
                        this.parent.addChildField(field, index);
                    }
                    else {
                        this.addChildField(field);
                    }
                }
            }
            else if ((_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.types.includes(DragDropType.Type)) {
                if (this.dragDropService.dragging) {
                    if (this.parent && this.dropTargetPlacement !== DropPlacement.self) {
                        this.parent.addChildType(this.dragDropService.dragging, this.getDropPlacementIndex());
                    }
                    else {
                        this.addChildType(this.dragDropService.dragging);
                    }
                }
            }
        }
        this.dragDropService.endDrag();
        this.resetDrop();
    }
    onMouseOver(event) {
        event.stopPropagation();
        this.zone.run(() => {
            this.isHovering = true;
            this.title = this.dragDropService.dragging == null ?
                `Click to edit ${this.formlyDesignerService.getTypeName(this.field.type)}` :
                null;
        });
    }
    onMouseOut() {
        this.isHovering = false;
    }
    onWindowMouseUp() {
        this.resetDrop();
    }
    addChildField(field, index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isFieldGroup) {
                return;
            }
            if (!this.fieldsService.checkField(field, this.formlyDesignerService.designerFields, this.field)) {
                return;
            }
            const updatedField = cloneDeep(this.field);
            if (!updatedField.fieldGroup) {
                return;
            }
            const fieldIndex = (index == null || isNaN(index)) ? updatedField.fieldGroup.length :
                Math.min(updatedField.fieldGroup.length, Math.max(0, index));
            updatedField.fieldGroup.splice(fieldIndex, 0, field);
            return timer(0)
                .pipe(tap(() => this.formlyDesignerService.updateField(this.field, updatedField)), catchError(() => NEVER), map(() => undefined)).toPromise();
        });
    }
    addChildType(type, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const field = this.formlyDesignerService.createField(type);
            yield this.addChildField(field, index);
        });
    }
    /**
     * @param dropField - field to ignore for index determination
     */
    getDropPlacementIndex(dropField) {
        var _a, _b, _c;
        if (this.parent && this.dropTargetPlacement !== DropPlacement.self) {
            const parentChildren = dropField ?
                (_a = this.parentParentService) === null || _a === void 0 ? void 0 : _a.children.filter(fd => { var _a; return fd.designerId !== ((_a = dropField.templateOptions) === null || _a === void 0 ? void 0 : _a.$designerId); }) :
                (_b = this.parentParentService) === null || _b === void 0 ? void 0 : _b.children;
            const dropIndex = (_c = parentChildren === null || parentChildren === void 0 ? void 0 : parentChildren.indexOf(this)) !== null && _c !== void 0 ? _c : 0;
            return this.dropTargetPlacement === DropPlacement.before ? dropIndex : dropIndex + 1;
        }
        return;
    }
    resetDrop() {
        this.dropTargetCounter = 0;
        this.dropTargetPlacement = null;
        if (this.isDropTarget) {
            this.dragDropService.dropTarget = null;
        }
    }
}
FormlyDesignerFieldWrapperComponent.ɵfac = function FormlyDesignerFieldWrapperComponent_Factory(t) { return new (t || FormlyDesignerFieldWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DragDropService), ɵngcc0.ɵɵdirectiveInject(FieldsService), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ParentService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ParentService, 12)); };
FormlyDesignerFieldWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyDesignerFieldWrapperComponent, selectors: [["formly-designer-field-wrapper"]], viewQuery: function FormlyDesignerFieldWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c1, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, hostBindings: function FormlyDesignerFieldWrapperComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FormlyDesignerFieldWrapperComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            ParentService,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 10, consts: [["draggable", "true", 1, "designer-content", 3, "title", "ngClass", "dragstart", "dragend", "dragenter", "dragleave", "drop", "mouseout"], ["content", ""], ["fieldComponent", ""], ["class", "designer-drop-target-before", 4, "ngIf"], ["class", "designer-drop-target-after", 4, "ngIf"], [1, "designer-drop-target-before"], [1, "designer-drop-target-after"]], template: function FormlyDesignerFieldWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("dragstart", function FormlyDesignerFieldWrapperComponent_Template_div_dragstart_0_listener($event) { return ctx.onDragStart($event); })("dragend", function FormlyDesignerFieldWrapperComponent_Template_div_dragend_0_listener() { return ctx.onDragEnd(); })("dragenter", function FormlyDesignerFieldWrapperComponent_Template_div_dragenter_0_listener($event) { return ctx.onDragEnter($event); })("dragleave", function FormlyDesignerFieldWrapperComponent_Template_div_dragleave_0_listener($event) { return ctx.onDragLeave($event); })("drop", function FormlyDesignerFieldWrapperComponent_Template_div_drop_0_listener($event) { return ctx.onDrop($event); })("mouseout", function FormlyDesignerFieldWrapperComponent_Template_div_mouseout_0_listener() { return ctx.onMouseOut(); });
        ɵngcc0.ɵɵtemplate(2, FormlyDesignerFieldWrapperComponent_ng_template_2_Template, 0, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, FormlyDesignerFieldWrapperComponent_div_4_Template, 1, 0, "div", 3);
        ɵngcc0.ɵɵtemplate(5, FormlyDesignerFieldWrapperComponent_div_5_Template, 1, 0, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.title)("ngClass", ɵngcc0.ɵɵpureFunction5(4, _c2, ctx.isSubject, ctx.isDragSource, ctx.isDragging, ctx.isDropTargetSelf, ctx.isHovering && !ctx.isDragging));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isDropTargetBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isDropTargetAfter);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], styles: ["[_nghost-%COMP%] {\n      display: flex;\n      position: relative;\n      justify-content: flex-start;\n      align-content: flex-start;\n      align-items: flex-start;\n      margin: .25rem;\n    }\n    .designer-content[_ngcontent-%COMP%] {\n      border: 1px dashed #000;\n      border-radius: 5px;\n      min-height: 2rem;\n      padding: .25em 1em;\n      width: 100%;\n    }\n    .designer-content.designer-hover[_ngcontent-%COMP%] {\n      background-color: #f0f4c3;\n      border-color: #00c853;\n      cursor: pointer;\n    }\n    .designer-content.designer-subject[_ngcontent-%COMP%] {\n      border-color: #00c853;\n      border-style: solid;\n      border-width: 2px;\n    }\n    .designer-content.designer-drop-hint[_ngcontent-%COMP%] {\n      background-color: pink;\n      border-color: #bbdefb;\n    }\n    .designer-content.designer-drop-target[_ngcontent-%COMP%] {\n      background-color: #f0f4c3;\n      border-color: #00c853;\n    }\n    .designer-drag-source[_ngcontent-%COMP%] {\n      opacity: .4;\n    }\n    .designer-drop-target-before[_ngcontent-%COMP%] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      background-color: aqua;\n      height: 12px;\n      pointer-events: none;\n      z-index: 1;\n    }\n    .designer-drop-target-after[_ngcontent-%COMP%] {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: yellow;\n      height: 12px;\n      pointer-events: none;\n      z-index: 1;\n    }"] });
FormlyDesignerFieldWrapperComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: DragDropService },
    { type: FieldsService },
    { type: FormlyDesignerService },
    { type: NgZone },
    { type: ParentService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ParentService, decorators: [{ type: SkipSelf }, { type: Optional }] }
];
FormlyDesignerFieldWrapperComponent.propDecorators = {
    fieldComponent: [{ type: ViewChild, args: ['fieldComponent', { read: ViewContainerRef, static: true },] }],
    content: [{ type: ViewChild, args: ['content', { read: ElementRef, static: true },] }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerFieldWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-field-wrapper',
                template: `
    <div #content class="designer-content" [title]="title"
      [ngClass]="{
        'designer-subject': isSubject,
        'designer-drag-source': isDragSource,
        'designer-drop-hint': isDragging,
        'designer-drop-target': isDropTargetSelf,
        'designer-hover': isHovering && !isDragging
      }"
      draggable="true" (dragstart)="onDragStart($event)" (dragend)="onDragEnd()"
      (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
      (mouseout)="onMouseOut()">
      <ng-template #fieldComponent></ng-template>
    </div>
    <div *ngIf="isDropTargetBefore" class="designer-drop-target-before"></div>
    <div *ngIf="isDropTargetAfter" class="designer-drop-target-after"></div>
  `,
                providers: [
                    ParentService,
                ],
                styles: [`
    :host {
      display: flex;
      position: relative;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      margin: .25rem;
    }
    .designer-content {
      border: 1px dashed #000;
      border-radius: 5px;
      min-height: 2rem;
      padding: .25em 1em;
      width: 100%;
    }
    .designer-content.designer-hover {
      background-color: #f0f4c3;
      border-color: #00c853;
      cursor: pointer;
    }
    .designer-content.designer-subject {
      border-color: #00c853;
      border-style: solid;
      border-width: 2px;
    }
    .designer-content.designer-drop-hint {
      background-color: pink;
      border-color: #bbdefb;
    }
    .designer-content.designer-drop-target {
      background-color: #f0f4c3;
      border-color: #00c853;
    }
    .designer-drag-source {
      opacity: .4;
    }
    .designer-drop-target-before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-color: aqua;
      height: 12px;
      pointer-events: none;
      z-index: 1;
    }
    .designer-drop-target-after {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: yellow;
      height: 12px;
      pointer-events: none;
      z-index: 1;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: DragDropService }, { type: FieldsService }, { type: FormlyDesignerService }, { type: ɵngcc0.NgZone }, { type: ParentService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ParentService, decorators: [{
                type: SkipSelf
            }, {
                type: Optional
            }] }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef, static: true }]
        }], content: [{
            type: ViewChild,
            args: ['content', { read: ElementRef, static: true }]
        }] }); })();

const fieldComponents = [];
const wrapperComponents = [
    FormlyDesignerWrapperComponent,
    FormlyDesignerFieldWrapperComponent
];
class Config {
    constructor(designerExtension) {
        this.wrappers = [
            { name: DESIGNER_WRAPPER_NAME, component: FormlyDesignerWrapperComponent },
            { name: FIELD_DESIGNER_WRAPPER_NAME, component: FormlyDesignerFieldWrapperComponent },
        ];
        this.extensions = [
            { name: 'designer', extension: designerExtension }
        ];
    }
}
Config.ɵfac = function Config_Factory(t) { return new (t || Config)(ɵngcc0.ɵɵinject(DesignerExtension)); };
Config.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Config, factory: Config.ɵfac });
Config.ctorParameters = () => [
    { type: DesignerExtension }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Config, [{
        type: Injectable
    }], function () { return [{ type: DesignerExtension }]; }, null); })();

class FormlyDesignerComponent {
    constructor(dragDropService, fieldsService, formBuilder, formlyDesignerService, parentService) {
        this.dragDropService = dragDropService;
        this.fieldsService = fieldsService;
        this.formBuilder = formBuilder;
        this.formlyDesignerService = formlyDesignerService;
        this.parentService = parentService;
        this.fieldsChange = new EventEmitter();
        this.modelChange = new EventEmitter();
        this.types = [];
        this.wrappers = [];
        this.properties = [];
        this.debugFields = [];
        this.dropTargetCounter = 0;
        this.options = {};
        this.subscriptions = [];
        parentService.parent = this;
        // Editor forms will be restricted to a single field depth; all designer keys should be
        // complex (e.g. "templateOptions.some.property")
        this.form = this.formBuilder.group({});
        this.isDragging$ = this.dragDropService.dragging$.pipe(map(dragging => dragging != null));
    }
    get designerId() { return ''; }
    get disabled() {
        return this.formlyDesignerService.disabled;
    }
    set disabled(value) {
        this.formlyDesignerService.disabled = value;
    }
    get fields() {
        return this.formlyDesignerService.fields;
    }
    set fields(value) {
        this.formlyDesignerService.fields = value;
    }
    get model() {
        return this.formlyDesignerService.model;
    }
    set model(value) {
        this.formlyDesignerService.model = value;
    }
    ngOnInit() {
        this.subscriptions.push(this.formlyDesignerService.designerFields$
            .subscribe(fields => {
            // Clear the existing children before the form reset
            this.parentService.clearChildren();
            this.options = {};
            this.form = this.formBuilder.group({});
            this.fieldsChange.emit(this.formlyDesignerService.createPrunedFields(fields, FieldType.Plain));
        }), merge(this.formlyDesignerService.model$, this.form.valueChanges)
            .pipe(debounceTime(50))
            .subscribe(() => this.modelChange.emit(this.formlyDesignerService.model)));
    }
    ngOnDestroy() {
        this.subscriptions.splice(0).forEach(subscription => subscription.unsubscribe());
    }
    onFieldSelected(field) {
        timer(0).pipe(tap(() => {
            if (this.fieldsService.checkField(field, this.formlyDesignerService.designerFields)) {
                this.formlyDesignerService.addField(field);
            }
        }), catchError(() => NEVER)).subscribe();
    }
    onDragEnter(event) {
        event.preventDefault();
        this.dropTargetCounter++;
    }
    onDragLeave() {
        if (this.dropTargetCounter > 0) {
            this.dropTargetCounter--;
        }
    }
    onDragOver(event) {
        event.preventDefault();
    }
    onDrop(event) {
        if (this.fields.length) {
            return;
        }
        if (!isString$1(this.dragDropService.dragging)) {
            return;
        }
        this.addChildType(this.dragDropService.dragging);
        event.preventDefault();
    }
    addChildField(field, index) {
        this.formlyDesignerService.addField(field, index);
    }
    addChildType(type, index) {
        const field = this.formlyDesignerService.createField(type);
        this.addChildField(field, index);
    }
}
FormlyDesignerComponent.ɵfac = function FormlyDesignerComponent_Factory(t) { return new (t || FormlyDesignerComponent)(ɵngcc0.ɵɵdirectiveInject(DragDropService), ɵngcc0.ɵɵdirectiveInject(FieldsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService), ɵngcc0.ɵɵdirectiveInject(ParentService)); };
FormlyDesignerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyDesignerComponent, selectors: [["formly-designer"]], viewQuery: function FormlyDesignerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formlyFormContainer = _t.first);
    } }, inputs: { disabled: "disabled", fields: "fields", model: "model" }, outputs: { fieldsChange: "fieldsChange", modelChange: "modelChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            ParentService,
        ])], decls: 4, vars: 3, consts: [["novalidate", "", 3, "formGroup"], [3, "options", "model", "form", "fields", 4, "ngIf", "ngIfElse"], ["placeholder", ""], [3, "options", "model", "form", "fields"], [1, "content", "d-flex", "justify-content-center", "align-items-center", 3, "ngClass", "dragenter", "dragleave", "dragover", "drop"]], template: function FormlyDesignerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵtemplate(1, FormlyDesignerComponent_formly_form_1_Template, 2, 7, "formly-form", 1);
        ɵngcc0.ɵɵtemplate(2, FormlyDesignerComponent_ng_template_2_Template, 4, 6, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fields.length > 0)("ngIfElse", _r1);
    } }, directives: [ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgIf, ɵngcc1.FormlyForm, ɵngcc2.NgClass], pipes: [ɵngcc2.AsyncPipe], styles: ["\n    formly-designer > form > .content {\n      border: 1px dashed #000;\n      border-radius: 5px;\n      min-height: 2rem;\n      padding: 1.5em 1em 0 1em;\n      width: 100%;\n    }\n    formly-designer > form > .content.drop-hint {\n      background-color: #e3f2fd;\n      border-color: #bbdefb;\n    }\n    formly-designer > form > .content.drop-target {\n      background-color: #f0f4c3;\n      border-color: #00c853;\n    }\n    formly-designer > form > .content > div {\n      padding: 2rem;\n      padding-bottom: 4rem;\n      font-size: 64pt;\n      pointer-events: none;\n    }\n    formly-designer-field-picker .form-group > .input-group > formly-designer-type-select > select {\n      border-radius: .25rem 0 0 .25rem;\n      border-right: 0;\n    }\n    formly-designer-wrapper-editor .card > .card-body .form-control {\n      width: 100%;\n    }\n    formly-designer-wrapper-picker .form-group > .input-group > formly-designer-wrapper-select > select {\n      border-radius: .25rem 0 0 .25rem;\n      border-right: 0;\n    }\n  "], encapsulation: 2 });
FormlyDesignerComponent.ctorParameters = () => [
    { type: DragDropService },
    { type: FieldsService },
    { type: FormBuilder },
    { type: FormlyDesignerService },
    { type: ParentService }
];
FormlyDesignerComponent.propDecorators = {
    formlyFormContainer: [{ type: ViewChild, args: ['formlyFormContainer', { read: ViewContainerRef, static: true },] }],
    fieldsChange: [{ type: Output }],
    modelChange: [{ type: Output }],
    disabled: [{ type: Input }],
    fields: [{ type: Input }],
    model: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer',
                template: `
    <form novalidate [formGroup]="form">
      <formly-form *ngIf="fields.length > 0; else placeholder" [options]="options" [model]="model" [form]="form" [fields]="(formlyDesignerService.designerFields$ | async) ?? []">
      </formly-form>
      <ng-template #placeholder>
        <div class="content d-flex justify-content-center align-items-center"
          [ngClass]="{ 'drop-hint': isDragging$ | async, 'drop-target': dropTargetCounter > 0 }"
          (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave()" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <div>+</div>
        </div>
      </ng-template>
    </form>
    <!--<div>
      Designer Fields:
      <pre>{{ formlyDesignerService.designerFields$ | async | decycle | json }}</pre>
    </div>-->
  `,
                providers: [
                    ParentService,
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [`
    formly-designer > form > .content {
      border: 1px dashed #000;
      border-radius: 5px;
      min-height: 2rem;
      padding: 1.5em 1em 0 1em;
      width: 100%;
    }
    formly-designer > form > .content.drop-hint {
      background-color: #e3f2fd;
      border-color: #bbdefb;
    }
    formly-designer > form > .content.drop-target {
      background-color: #f0f4c3;
      border-color: #00c853;
    }
    formly-designer > form > .content > div {
      padding: 2rem;
      padding-bottom: 4rem;
      font-size: 64pt;
      pointer-events: none;
    }
    formly-designer-field-picker .form-group > .input-group > formly-designer-type-select > select {
      border-radius: .25rem 0 0 .25rem;
      border-right: 0;
    }
    formly-designer-wrapper-editor .card > .card-body .form-control {
      width: 100%;
    }
    formly-designer-wrapper-picker .form-group > .input-group > formly-designer-wrapper-select > select {
      border-radius: .25rem 0 0 .25rem;
      border-right: 0;
    }
  `]
            }]
    }], function () { return [{ type: DragDropService }, { type: FieldsService }, { type: ɵngcc3.FormBuilder }, { type: FormlyDesignerService }, { type: ParentService }]; }, { fieldsChange: [{
            type: Output
        }], modelChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], fields: [{
            type: Input
        }], model: [{
            type: Input
        }], formlyFormContainer: [{
            type: ViewChild,
            args: ['formlyFormContainer', { read: ViewContainerRef, static: true }]
        }] }); })();

const FIELD_EDITOR_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldEditorComponent),
    multi: true
};
class FieldEditorComponent {
    constructor(fieldsService, fb, formlyDesignerConfig) {
        this.fieldsService = fieldsService;
        this.fb = fb;
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.fieldGroup = false;
        this.showType = false;
        this.showWrappers = false;
        this.hasContent = false;
        this.subscriptions = [];
        this.field = {};
        this.fields = [];
        this.fieldArray = false;
        this.invalid = false;
        this.onChange = (_) => { };
        this.onTouched = () => { };
        this.form = fb.group({
            key: this.key = fb.control(''),
            className: this.className = fb.control(''),
            fieldGroupClassName: this.fieldGroupClassName = fb.control(''),
            type: this.type = fb.control('')
        }, { validator: (control) => this.validator(control) });
        this.fieldForm = fb.group({});
    }
    ngOnInit() {
        this.subscriptions.push(this.type.valueChanges
            .subscribe(() => this.onTypeChange()));
        this.subscriptions.push(this.form.statusChanges
            .pipe(debounceTime(0))
            .subscribe(() => this.invalid = this.form.invalid));
        this.subscribeValueChanges();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.subscriptions.splice(0).forEach(subscription => subscription.unsubscribe());
    }
    writeValue(obj) {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.updateField(obj);
        this.form.markAsPristine();
        this.form.markAsUntouched();
        this.subscribeValueChanges();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.form.disable();
        }
        else {
            this.form.enable();
        }
    }
    subscribeValueChanges() {
        this.valueChangesSubscription = merge(this.fieldForm.valueChanges, this.form.valueChanges)
            .pipe(debounceTime(0))
            .subscribe(() => this.updateValue());
    }
    updateField(field) {
        if (!isObject(field)) {
            field = {};
        }
        this.key.setValue(isString(field.key) ? field.key : '');
        this.className.setValue(isString(field.className) ? field.className : '');
        this.fieldGroupClassName.setValue(isString(field.fieldGroupClassName) ? field.fieldGroupClassName : '');
        this.type.setValue(isString(field.type) ? field.type : '');
        this.fields = this.fieldsService.getTypeFields(this.type.value);
        this.fieldForm = this.fb.group({});
        this.field = cloneDeep(field);
    }
    updateValue() {
        if (!this.onChange) {
            return;
        }
        const field = this.field;
        field.key = this.key.value;
        field.className = this.className.value;
        field.fieldGroupClassName = this.fieldGroupClassName.value;
        field.type = this.type.value;
        this.onChange(field);
    }
    onTypeChange() {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        const type = this.type.value;
        this.fields = this.fieldsService.getTypeFields(type);
        const designerType = this.formlyDesignerConfig.types[type];
        this.fieldArray = (designerType === null || designerType === void 0 ? void 0 : designerType.fieldArray) != null;
        this.fieldForm = this.fb.group({});
        this.field = Object.assign({}, this.field);
        this.subscribeValueChanges();
    }
    onWrappersSelected(field) {
        this.updateField(field);
    }
    validator(control) {
        if (this.fieldGroup) {
            return null;
        }
        const type = control.get('type');
        const hasType = isString(type.value) && type.value.trim().length > 0;
        const result = { type: false };
        if (this.showType && !hasType) {
            result.type = true;
        }
        return result.type ? result : null;
    }
}
FieldEditorComponent.ɵfac = function FieldEditorComponent_Factory(t) { return new (t || FieldEditorComponent)(ɵngcc0.ɵɵdirectiveInject(FieldsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig)); };
FieldEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FieldEditorComponent, selectors: [["formly-designer-field-editor"]], viewQuery: function FieldEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.blockElRef = _t.first);
    } }, inputs: { fieldGroup: "fieldGroup", showType: "showType", showWrappers: "showWrappers", hasContent: "hasContent" }, features: [ɵngcc0.ɵɵProvidersFeature([
            FIELD_EDITOR_CONTROL_VALUE_ACCESSOR
        ])], ngContentSelectors: _c9, decls: 15, vars: 9, consts: [["novalidate", "", 3, "formGroup"], [1, "card"], [1, "card-header", 3, "ngClass"], [1, "form-group"], [1, "form-control-label"], ["formControlName", "key", 1, "form-control"], ["class", "form-group", 4, "ngIf"], ["class", "form-group", 3, "ngClass", 4, "ngIf"], [1, "card-body"], ["block", ""], [3, "form", "fields", "model", 4, "ngIf"], ["formControlName", "className", 1, "form-control"], ["formControlName", "fieldGroupClassName", 1, "form-control"], [1, "form-group", 3, "ngClass"], ["formControlName", "type", 3, "fieldGroup", "type"], ["class", "form-control-feedback", 4, "ngIf"], [1, "form-control-feedback"], [3, "field", "selected"], [3, "form", "fields", "model"]], template: function FieldEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "label", 4);
        ɵngcc0.ɵɵtext(5, "key");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "input", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, FieldEditorComponent_div_7_Template, 4, 0, "div", 6);
        ɵngcc0.ɵɵtemplate(8, FieldEditorComponent_div_8_Template, 4, 0, "div", 6);
        ɵngcc0.ɵɵtemplate(9, FieldEditorComponent_div_9_Template, 5, 6, "div", 7);
        ɵngcc0.ɵɵtemplate(10, FieldEditorComponent_div_10_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8, 9);
        ɵngcc0.ɵɵtemplate(13, FieldEditorComponent_formly_form_13_Template, 1, 3, "formly-form", 10);
        ɵngcc0.ɵɵprojection(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c8, !ctx.hasContent && ctx.fields.length === 0));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formlyDesignerConfig.settings.showClassName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldGroup && ctx.formlyDesignerConfig.settings.showClassName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showWrappers);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fields.length > 0);
    } }, directives: function () { return [ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgClass, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgIf, TypeSelectComponent, WrappersPickerComponent, ɵngcc1.FormlyForm]; }, styles: [".card-header.solo[_ngcontent-%COMP%] {\n      border-bottom: 0;\n    }\n    .card-header.solo[_ngcontent-%COMP%]    + .card-body[_ngcontent-%COMP%] {\n      display: none;\n    }"] });
FieldEditorComponent.ctorParameters = () => [
    { type: FieldsService },
    { type: FormBuilder },
    { type: FormlyDesignerConfig }
];
FieldEditorComponent.propDecorators = {
    fieldGroup: [{ type: Input }],
    showType: [{ type: Input }],
    showWrappers: [{ type: Input }],
    hasContent: [{ type: Input }],
    blockElRef: [{ type: ViewChild, args: ['block', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldEditorComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-field-editor',
                template: `
    <form [formGroup]="form" novalidate>
      <div class="card">
        <div class="card-header" [ngClass]="{solo: !hasContent && fields.length === 0}">
          <div class="form-group">
            <label class="form-control-label">key</label>
            <input formControlName="key" class="form-control">
          </div>
          <div *ngIf="formlyDesignerConfig.settings.showClassName" class="form-group">
            <label class="form-control-label">className</label>
            <input formControlName="className" class="form-control">
          </div>
          <div *ngIf="fieldGroup && formlyDesignerConfig.settings.showClassName" class="form-group">
            <label class="form-control-label">fieldGroupClassName</label>
            <input formControlName="fieldGroupClassName" class="form-control">
          </div>
          <div *ngIf="showType" class="form-group"
            [ngClass]="{'has-danger': form.hasError('type') && (type.dirty || type.touched)}">
            <label class="form-control-label">type</label>
            <formly-designer-type-select formControlName="type" [fieldGroup]="fieldGroup" [type]="type.value"></formly-designer-type-select>
            <div *ngIf="form.hasError('type') && (type.dirty || type.touched)" class="form-control-feedback">
              type required.
            </div>
          </div>
          <div *ngIf="showWrappers" class="form-group">
            <label class="form-control-label">wrappers</label>
            <formly-designer-wrappers-picker [field]="field"
              (selected)="onWrappersSelected($event)">
            </formly-designer-wrappers-picker>
          </div>
        </div>
        <div #block class="card-body">
          <formly-form *ngIf="fields.length > 0" [form]="fieldForm" [fields]="fields" [model]="field">
          </formly-form>
          <ng-content></ng-content>
        </div>
      </div>
    </form>
  `,
                providers: [
                    FIELD_EDITOR_CONTROL_VALUE_ACCESSOR
                ],
                styles: [`
    .card-header.solo {
      border-bottom: 0;
    }
    .card-header.solo + .card-body {
      display: none;
    }
  `]
            }]
    }], function () { return [{ type: FieldsService }, { type: ɵngcc3.FormBuilder }, { type: FormlyDesignerConfig }]; }, { fieldGroup: [{
            type: Input
        }], showType: [{
            type: Input
        }], showWrappers: [{
            type: Input
        }], hasContent: [{
            type: Input
        }], blockElRef: [{
            type: ViewChild,
            args: ['block', { static: true }]
        }] }); })();

class FieldPickerComponent {
    constructor(fb, formlyDesignerConfig, formlyDesignerService) {
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formlyDesignerService = formlyDesignerService;
        this.selected = new EventEmitter();
        this.fieldEdit = new FormControl({});
        this.fieldGroup = false;
        this.form = fb.group({
            type: this.type = fb.control('', Validators.compose([Validators.required, Validators.pattern(/^\s*\S.*$/)]))
        });
    }
    get typeName() {
        return this.formlyDesignerService.getTypeName(this.type.value);
    }
    get $modal() {
        var _a;
        return $((_a = this.modalRef) === null || _a === void 0 ? void 0 : _a.nativeElement);
    }
    add() {
        const type = this.type.value;
        const field = {};
        if (type !== 'formly-group') {
            field.type = type;
        }
        const designerType = this.formlyDesignerConfig.types[type] || {};
        if (designerType.fieldArray) {
            field.fieldArray = { fieldGroup: [] };
        }
        if (this.fieldGroup = (type === 'formly-group' || designerType.fieldGroup != null)) {
            field.fieldGroup = [];
        }
        this.fieldEdit.setValue(field);
        this.$modal.modal('show');
    }
    onApply() {
        this.selected.emit(this.fieldEdit.value);
        this.$modal.modal('hide');
    }
}
FieldPickerComponent.ɵfac = function FieldPickerComponent_Factory(t) { return new (t || FieldPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService)); };
FieldPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FieldPickerComponent, selectors: [["formly-designer-field-picker"]], viewQuery: function FieldPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalRef = _t.first);
    } }, outputs: { selected: "selected" }, decls: 24, vars: 6, consts: [["novalidate", "", 3, "formGroup"], [1, "form-group"], [1, "input-group"], ["formControlName", "type"], ["type", "button", 1, "btn", "btn-secondary", 3, "disabled", "click"], ["tabindex", "-1", "role", "dialog", 1, "modal", "fade"], ["modal", ""], ["role", "document", 1, "modal-dialog", "modal-lg"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Cancel", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], [3, "fieldGroup", "formControl"], ["editor", ""], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"]], template: function FieldPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "formly-designer-type-select", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function FieldPickerComponent_Template_button_click_4_listener() { return ctx.add(); });
        ɵngcc0.ɵɵtext(5, " Add ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5, 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "h5", 10);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 11);
        ɵngcc0.ɵɵelementStart(14, "span", 12);
        ɵngcc0.ɵɵtext(15, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 13);
        ɵngcc0.ɵɵelement(17, "formly-designer-field-editor", 14, 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 16);
        ɵngcc0.ɵɵelementStart(20, "button", 17);
        ɵngcc0.ɵɵtext(21, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 18);
        ɵngcc0.ɵɵlistener("click", function FieldPickerComponent_Template_button_click_22_listener() { return ctx.onApply(); });
        ɵngcc0.ɵɵtext(23, "Apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(18);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1("Add ", ctx.typeName, "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("fieldGroup", ctx.fieldEdit.value.fieldGroup)("formControl", ctx.fieldEdit);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", _r1.invalid);
    } }, directives: function () { return [ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, TypeSelectComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, FieldEditorComponent, ɵngcc3.FormControlDirective]; }, styles: [".btn[_ngcontent-%COMP%]:not(:disabled) {\n      cursor: pointer;\n    }\n    .input-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n      border-radius: 0 .25rem .25rem 0;\n    }\n    .input-group[_ngcontent-%COMP%], .modal-header[_ngcontent-%COMP%] {\n      display: flex;\n    }\n    .modal-header[_ngcontent-%COMP%] {\n      justify-content: space-between;\n    }\n    formly-designer-type-select[_ngcontent-%COMP%] {\n      flex-grow: 2;\n    }"] });
FieldPickerComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: FormlyDesignerConfig },
    { type: FormlyDesignerService }
];
FieldPickerComponent.propDecorators = {
    modalRef: [{ type: ViewChild, args: ['modal', { static: true },] }],
    selected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldPickerComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-field-picker',
                template: `
    <form novalidate [formGroup]="form">
      <div class="form-group">
        <div class="input-group">
          <formly-designer-type-select formControlName="type">
          </formly-designer-type-select>
          <button type="button" class="btn btn-secondary" [disabled]="form.invalid" (click)="add()">
            Add
          </button>
        </div>
      </div>
      <div #modal class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add {{ typeName }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <formly-designer-field-editor #editor [fieldGroup]="fieldEdit.value.fieldGroup" [formControl]="fieldEdit">
              </formly-designer-field-editor>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="onApply()"
                [disabled]="editor.invalid">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  `,
                styles: [`
    .btn:not(:disabled) {
      cursor: pointer;
    }
    .input-group > .btn {
      border-radius: 0 .25rem .25rem 0;
    }
    .input-group, .modal-header {
      display: flex;
    }
    .modal-header {
      justify-content: space-between;
    }
    formly-designer-type-select {
      flex-grow: 2;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: FormlyDesignerConfig }, { type: FormlyDesignerService }]; }, { selected: [{
            type: Output
        }], modalRef: [{
            type: ViewChild,
            args: ['modal', { static: true }]
        }] }); })();

class PropertiesComponent {
    constructor(fieldsService, formlyDesignerConfig, formlyDesignerService) {
        this.fieldsService = fieldsService;
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formlyDesignerService = formlyDesignerService;
        this.subscriptions = [];
        this.fieldGroup = false;
        this.fieldEdit = new FormControl({});
        this.field = null;
    }
    get hasField() { return this.field == null; }
    ngOnInit() {
        this.subscriptions.push(this.formlyDesignerService.designerFields$.subscribe(fields => {
            var _a, _b, _c;
            const designerId = (_b = (_a = this.field) === null || _a === void 0 ? void 0 : _a.templateOptions) === null || _b === void 0 ? void 0 : _b.$designerId;
            this.setField((_c = this.fieldsService.find(designerId, fields)) !== null && _c !== void 0 ? _c : null);
        }), this.formlyDesignerService.selectedField$.subscribe(field => {
            this.setField(field);
        }));
    }
    ngOnDestroy() {
        this.subscriptions.splice(0).forEach(subscription => subscription.unsubscribe());
    }
    remove() {
        if (this.field) {
            this.formlyDesignerService.removeField(this.field);
        }
    }
    accept() {
        if (!this.fieldsService.checkField(this.fieldEdit.value, this.formlyDesignerService.designerFields)) {
            return;
        }
        timer(0).subscribe(() => {
            this.formlyDesignerService.updateField(this.field, this.fieldEdit.value);
        });
    }
    cancel() {
        this.setField(null);
    }
    setField(field) {
        var _a;
        if (field !== this.field) {
            this.field = field;
            this.fieldGroup = (field === null || field === void 0 ? void 0 : field.type) === 'formly-group' ||
                ((field === null || field === void 0 ? void 0 : field.type) && ((_a = this.formlyDesignerConfig.types[field.type]) === null || _a === void 0 ? void 0 : _a.fieldGroup)) != null;
            this.fieldEdit.setValue(field ? cloneDeep(field) : {});
        }
    }
}
PropertiesComponent.ɵfac = function PropertiesComponent_Factory(t) { return new (t || PropertiesComponent)(ɵngcc0.ɵɵdirectiveInject(FieldsService), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService)); };
PropertiesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PropertiesComponent, selectors: [["formly-designer-properties"]], hostVars: 2, hostBindings: function PropertiesComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("d-none", ctx.hasField);
    } }, decls: 9, vars: 6, consts: [[3, "fieldGroup", "hasContent", "showType", "showWrappers", "formControl"], ["editor", ""], [1, "footer"], [1, "btn", "btn-secondary", "mr-1", 3, "click"], [1, "btn", "btn-secondary", "ml-auto", "mr-1", 3, "click"], [1, "btn", "btn-primary", 3, "disabled", "click"]], template: function PropertiesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "formly-designer-field-editor", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function PropertiesComponent_Template_button_click_3_listener() { return ctx.remove(); });
        ɵngcc0.ɵɵtext(4, "Remove");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵlistener("click", function PropertiesComponent_Template_button_click_5_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(6, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function PropertiesComponent_Template_button_click_7_listener() { return ctx.accept(); });
        ɵngcc0.ɵɵtext(8, "Apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("fieldGroup", ctx.fieldGroup)("hasContent", true)("showType", true)("showWrappers", true)("formControl", ctx.fieldEdit);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("disabled", _r0.invalid);
    } }, directives: [FieldEditorComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective], styles: [".footer[_ngcontent-%COMP%] {\n      display: flex;\n    }"] });
PropertiesComponent.ctorParameters = () => [
    { type: FieldsService },
    { type: FormlyDesignerConfig },
    { type: FormlyDesignerService }
];
PropertiesComponent.propDecorators = {
    hasField: [{ type: HostBinding, args: ['class.d-none',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PropertiesComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-properties',
                template: `
    <formly-designer-field-editor #editor [fieldGroup]="fieldGroup" [hasContent]="true" [showType]="true" [showWrappers]="true" [formControl]="fieldEdit">
      <div class="footer">
        <button (click)="remove()" class="btn btn-secondary mr-1">Remove</button>
        <button (click)="cancel()" class="btn btn-secondary ml-auto mr-1">Cancel</button>
        <button [disabled]="editor.invalid" (click)="accept()" class="btn btn-primary">Apply</button>
      </div>
    </formly-designer-field-editor>
  `,
                styles: [`
    .footer {
      display: flex;
    }
  `]
            }]
    }], function () { return [{ type: FieldsService }, { type: FormlyDesignerConfig }, { type: FormlyDesignerService }]; }, { hasField: [{
            type: HostBinding,
            args: ['class.d-none']
        }] }); })();

const TYPE_SELECT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TypeSelectComponent),
    multi: true
};
class TypeSelectComponent {
    constructor(formlyDesignerConfig) {
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formControl = new FormControl();
        this.types = [];
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    ngAfterViewInit() {
        this.updateTypes();
    }
    ngOnChanges(change) {
        if (change.fieldGroup) {
            this.updateTypes();
        }
    }
    ngOnInit() {
        this.valueChangesSubscription = this.formControl.valueChanges.subscribe(value => {
            if (this.onChange) {
                this.onChange(value);
            }
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    writeValue(obj) {
        this.formControl.setValue(obj);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.formControl.disable();
        }
        else {
            this.formControl.enable();
        }
    }
    updateTypes() {
        timer(0).subscribe(() => {
            this.types = this.getTypes();
            const type = this.fieldGroup && (this.type == null || this.type === '') ? 'formly-group' : this.type;
            if (this.types.some(option => option.value === type)) {
                this.formControl.setValue(type);
            }
            else if (this.types.length > 0) {
                this.formControl.setValue(this.types[0].value);
            }
        });
    }
    getTypes() {
        const types = [];
        const entries = Object.entries(this.formlyDesignerConfig.types);
        if (this.fieldGroup !== true) {
            entries.forEach(([key, value]) => {
                if (!value.fieldGroup) {
                    types.push({ label: key, value: key });
                }
            });
        }
        if (this.fieldGroup !== false) {
            types.push({ label: 'fieldGroup', value: 'formly-group' });
        }
        if (this.fieldGroup !== false) {
            entries.forEach(([key, value]) => {
                if (value.fieldGroup) {
                    types.push({ label: key, value: key });
                }
            });
        }
        return types;
    }
}
TypeSelectComponent.ɵfac = function TypeSelectComponent_Factory(t) { return new (t || TypeSelectComponent)(ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig)); };
TypeSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypeSelectComponent, selectors: [["formly-designer-type-select"]], inputs: { type: "type", fieldGroup: "fieldGroup" }, features: [ɵngcc0.ɵɵProvidersFeature([TYPE_SELECT_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[1, "custom-select", 3, "formControl"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function TypeSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵtemplate(1, TypeSelectComponent_option_1_Template, 2, 2, "option", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.types);
    } }, directives: [ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵNgSelectMultipleOption], styles: [_c11] });
TypeSelectComponent.ctorParameters = () => [
    { type: FormlyDesignerConfig }
];
TypeSelectComponent.propDecorators = {
    type: [{ type: Input }],
    fieldGroup: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeSelectComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-type-select',
                template: `
    <select [formControl]="formControl" class="custom-select">
      <option *ngFor="let type of types" [ngValue]="type.value">{{ type.label }}</option>
    </select>
  `,
                providers: [TYPE_SELECT_CONTROL_VALUE_ACCESSOR],
                styles: [`
    select {
      width: 100%;
    }
  `]
            }]
    }], function () { return [{ type: FormlyDesignerConfig }]; }, { type: [{
            type: Input
        }], fieldGroup: [{
            type: Input
        }] }); })();

class TypesComponent {
    constructor(dragDropService, formlyDesignerConfig) {
        this.dragDropService = dragDropService;
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.types = [];
    }
    ngOnInit() {
        this.types = this.getTypes();
    }
    onDragStart(event, type) {
        var _a;
        (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData(DragDropType.Type, type);
        this.dragDropService.beginDrag(type);
    }
    onDragEnd() {
        this.dragDropService.endDrag();
    }
    getTypes() {
        const types = [];
        const entries = Object.entries(this.formlyDesignerConfig.types);
        entries.forEach(([key, value]) => {
            if (!value.fieldGroup) {
                types.push({ label: key, value: key });
            }
        });
        types.push({ label: 'fieldGroup', value: 'formly-group' });
        entries.forEach(([key, value]) => {
            if (value.fieldGroup) {
                types.push({ label: key, value: key });
            }
        });
        return types;
    }
}
TypesComponent.ɵfac = function TypesComponent_Factory(t) { return new (t || TypesComponent)(ɵngcc0.ɵɵdirectiveInject(DragDropService), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig)); };
TypesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypesComponent, selectors: [["formly-designer-types"]], decls: 1, vars: 1, consts: [["draggable", "true", 3, "dragstart", "dragend", 4, "ngFor", "ngForOf"], ["draggable", "true", 3, "dragstart", "dragend"]], template: function TypesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TypesComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.types);
    } }, directives: [ɵngcc2.NgForOf], styles: ["[_nghost-%COMP%] {\n      display: flex;\n      flex-direction: column;\n    }\n    div[_ngcontent-%COMP%] {\n      margin: 2px;\n      padding: .5rem;\n      border-radius: .75rem;\n      background-color: #bbdefb;\n      line-break: anywhere;\n      white-space: pre-line;\n      cursor: grab;\n      user-select: none;\n    }"] });
TypesComponent.ctorParameters = () => [
    { type: DragDropService },
    { type: FormlyDesignerConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypesComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-types',
                template: `
    <div *ngFor="let type of types" draggable="true" (dragstart)="onDragStart($event, type.value)" (dragend)="onDragEnd()">
      {{ type.label }}
    </div>
  `,
                styles: [`
    :host {
      display: flex;
      flex-direction: column;
    }
    div {
      margin: 2px;
      padding: .5rem;
      border-radius: .75rem;
      background-color: #bbdefb;
      line-break: anywhere;
      white-space: pre-line;
      cursor: grab;
      user-select: none;
    }
  `]
            }]
    }], function () { return [{ type: DragDropService }, { type: FormlyDesignerConfig }]; }, null); })();

const WRAPPER_EDITOR_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WrapperEditorComponent),
    multi: true
};
class WrapperEditorComponent {
    constructor(fieldsService, formBuilder) {
        this.fieldsService = fieldsService;
        this.formBuilder = formBuilder;
        this.wrapper = null;
        this.subscriptions = [];
        this.invalid = false;
        this.fields = [];
        this.onChange = (value) => { };
        this.onTouched = () => { };
        this.fieldForm = formBuilder.group({});
    }
    ngOnInit() {
        this.subscriptions.push(this.fieldForm.statusChanges
            .pipe(switchMap(() => timer(0)))
            .subscribe(() => this.invalid = this.fieldForm.invalid));
        this.subscribeValueChanges();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.subscriptions.splice(0).forEach(subscription => subscription.unsubscribe());
    }
    ngOnChanges(changes) {
        if (changes.wrapper) {
            if (this.valueChangesSubscription) {
                this.valueChangesSubscription.unsubscribe();
            }
            this.fields = this.fieldsService.getWrapperFields(this.wrapper);
            this.fieldForm = this.formBuilder.group({});
            this.field = Object.assign({}, this.field);
            if (this.valueChangesSubscription) {
                this.subscribeValueChanges();
            }
        }
    }
    writeValue(obj) {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        if (!isObject(obj)) {
            obj = {};
        }
        this.fields = this.fieldsService.getWrapperFields(this.wrapper);
        this.fieldForm = this.formBuilder.group({});
        this.field = cloneDeep(obj);
        this.subscribeValueChanges();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.fieldForm.disable();
        }
        else {
            this.fieldForm.enable();
        }
    }
    subscribeValueChanges() {
        this.valueChangesSubscription = this.fieldForm.valueChanges
            .pipe(debounceTime(0))
            .subscribe(() => this.updateValue());
    }
    updateValue() {
        if (!this.onChange) {
            return;
        }
        this.onChange(this.field);
    }
}
WrapperEditorComponent.ɵfac = function WrapperEditorComponent_Factory(t) { return new (t || WrapperEditorComponent)(ɵngcc0.ɵɵdirectiveInject(FieldsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
WrapperEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WrapperEditorComponent, selectors: [["formly-designer-wrapper-editor"]], inputs: { wrapper: "wrapper" }, features: [ɵngcc0.ɵɵProvidersFeature([
            WRAPPER_EDITOR_CONTROL_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c9, decls: 5, vars: 4, consts: [["novalidate", "", 3, "formGroup"], [1, "card"], [1, "card-body"], [3, "form", "fields", "model"]], template: function WrapperEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "formly-form", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.fieldForm);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("form", ctx.fieldForm)("fields", ctx.fields)("model", ctx.field);
    } }, directives: [ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc1.FormlyForm], encapsulation: 2 });
WrapperEditorComponent.ctorParameters = () => [
    { type: FieldsService },
    { type: FormBuilder }
];
WrapperEditorComponent.propDecorators = {
    wrapper: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrapperEditorComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-wrapper-editor',
                template: `
    <form [formGroup]="fieldForm" novalidate>
      <div class="card">
        <div class="card-body">
          <formly-form [form]="fieldForm" [fields]="fields" [model]="field">
          </formly-form>
          <ng-content></ng-content>
        </div>
      </div>
    </form>
  `,
                providers: [
                    WRAPPER_EDITOR_CONTROL_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: FieldsService }, { type: ɵngcc3.FormBuilder }]; }, { wrapper: [{
            type: Input
        }] }); })();

class WrapperPickerComponent {
    constructor(formBuilder, formlyDesignerConfig, formlyDesignerService) {
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formlyDesignerService = formlyDesignerService;
        this.selected = new EventEmitter();
        this.fieldEdit = new FormControl({});
        this.form = formBuilder.group({
            wrapper: ['', Validators.compose([Validators.required, Validators.pattern(/^\s*\S.*$/)])]
        });
    }
    get wrapper() {
        var _a;
        return (_a = this.form.get('wrapper')) === null || _a === void 0 ? void 0 : _a.value;
    }
    get $modal() {
        var _a;
        return $((_a = this.modalRef) === null || _a === void 0 ? void 0 : _a.nativeElement);
    }
    add() {
        if (!this.wrapper) {
            return;
        }
        if (isObject(this.field)) {
            const field = cloneDeep(this.field);
            if (isArray(field.wrappers) && field.wrappers.length > 0) {
                field.wrappers.splice(field.wrappers.length - 1, 0, this.wrapper);
            }
            else {
                field.wrappers = [this.wrapper];
            }
            this.fieldEdit.setValue(field);
            const fields = this.formlyDesignerConfig.wrappers[this.wrapper].fields;
            if (isArray(fields) && fields.length > 0) {
                this.$modal.modal('show');
            }
            else {
                this.onApply();
            }
        }
    }
    onApply() {
        this.field = this.formlyDesignerService.createPrunedField(this.fieldEdit.value);
        this.selected.emit(this.fieldEdit.value);
        this.$modal.modal('hide');
    }
}
WrapperPickerComponent.ɵfac = function WrapperPickerComponent_Factory(t) { return new (t || WrapperPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService)); };
WrapperPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WrapperPickerComponent, selectors: [["formly-designer-wrapper-picker"]], viewQuery: function WrapperPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalRef = _t.first);
    } }, inputs: { field: "field" }, outputs: { selected: "selected" }, decls: 24, vars: 6, consts: [["novalidate", "", 3, "formGroup"], [1, "form-group"], [1, "input-group"], ["formControlName", "wrapper"], ["type", "button", 1, "btn", "btn-secondary", 3, "disabled", "click"], ["tabindex", "-1", "role", "dialog", 1, "modal", "fade"], ["modal", ""], ["role", "document", 1, "modal-dialog", "modal-lg"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Cancel", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], [3, "formControl", "wrapper"], ["editor", ""], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"]], template: function WrapperPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "formly-designer-wrapper-select", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function WrapperPickerComponent_Template_button_click_4_listener() { return ctx.add(); });
        ɵngcc0.ɵɵtext(5, " Add ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5, 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "h5", 10);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 11);
        ɵngcc0.ɵɵelementStart(14, "span", 12);
        ɵngcc0.ɵɵtext(15, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 13);
        ɵngcc0.ɵɵelement(17, "formly-designer-wrapper-editor", 14, 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 16);
        ɵngcc0.ɵɵelementStart(20, "button", 17);
        ɵngcc0.ɵɵtext(21, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 18);
        ɵngcc0.ɵɵlistener("click", function WrapperPickerComponent_Template_button_click_22_listener() { return ctx.onApply(); });
        ɵngcc0.ɵɵtext(23, "Apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(18);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.form.invalid);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1("Add ", ctx.wrapper, "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControl", ctx.fieldEdit)("wrapper", ctx.wrapper);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", _r1.invalid);
    } }, directives: function () { return [ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, WrapperSelectComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, WrapperEditorComponent, ɵngcc3.FormControlDirective]; }, styles: ["[_nghost-%COMP%] {\n      width: inherit;\n    }\n    .btn[_ngcontent-%COMP%]:not(:disabled) {\n      cursor: pointer;\n    }\n    .input-group[_ngcontent-%COMP%]    > .btn[_ngcontent-%COMP%] {\n      border-radius: 0 .25rem .25rem 0;\n    }\n    .input-group[_ngcontent-%COMP%], .modal-header[_ngcontent-%COMP%] {\n      display: flex;\n    }\n    .modal-header[_ngcontent-%COMP%] {\n      justify-content: space-between;\n    }\n    formly-designer-wrapper-select[_ngcontent-%COMP%] {\n      flex-grow: 2;\n    }"] });
WrapperPickerComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: FormlyDesignerConfig },
    { type: FormlyDesignerService }
];
WrapperPickerComponent.propDecorators = {
    modalRef: [{ type: ViewChild, args: ['modal', { static: true },] }],
    field: [{ type: Input }],
    selected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrapperPickerComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-wrapper-picker',
                template: `
    <form novalidate [formGroup]="form">
      <div class="form-group">
        <div class="input-group">
          <formly-designer-wrapper-select formControlName="wrapper">
          </formly-designer-wrapper-select>
          <button type="button" class="btn btn-secondary" [disabled]="form.invalid" (click)="add()">
            Add
          </button>
        </div>
      </div>
      <div #modal class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add {{ wrapper }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <formly-designer-wrapper-editor #editor [formControl]="fieldEdit" [wrapper]="wrapper">
              </formly-designer-wrapper-editor>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="onApply()"
                [disabled]="editor.invalid">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  `,
                styles: [`
    :host {
      width: inherit;
    }
    .btn:not(:disabled) {
      cursor: pointer;
    }
    .input-group > .btn {
      border-radius: 0 .25rem .25rem 0;
    }
    .input-group, .modal-header {
      display: flex;
    }
    .modal-header {
      justify-content: space-between;
    }
    formly-designer-wrapper-select {
      flex-grow: 2;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: FormlyDesignerConfig }, { type: FormlyDesignerService }]; }, { selected: [{
            type: Output
        }], field: [{
            type: Input
        }], modalRef: [{
            type: ViewChild,
            args: ['modal', { static: true }]
        }] }); })();

const WRAPPER_SELECT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WrapperSelectComponent),
    multi: true
};
class WrapperSelectComponent {
    constructor(formlyDesignerConfig) {
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formControl = new FormControl();
        this.wrappers = [];
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    ngAfterViewInit() {
        timer(0).subscribe(() => {
            this.wrappers = Object.keys(this.formlyDesignerConfig.wrappers);
            if (this.wrappers.length > 0) {
                this.formControl.setValue(this.wrappers[0]);
            }
        });
    }
    ngOnInit() {
        this.valueChangesSubscription = this.formControl.valueChanges.subscribe(value => {
            if (this.onChange) {
                this.onChange(value);
            }
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.valueChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    writeValue(obj) {
        this.formControl.setValue(obj);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.formControl.disable();
        }
        else {
            this.formControl.enable();
        }
    }
}
WrapperSelectComponent.ɵfac = function WrapperSelectComponent_Factory(t) { return new (t || WrapperSelectComponent)(ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig)); };
WrapperSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WrapperSelectComponent, selectors: [["formly-designer-wrapper-select"]], features: [ɵngcc0.ɵɵProvidersFeature([WRAPPER_SELECT_CONTROL_VALUE_ACCESSOR])], decls: 2, vars: 2, consts: [[1, "custom-select", 3, "formControl"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function WrapperSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵtemplate(1, WrapperSelectComponent_option_1_Template, 2, 2, "option", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.wrappers);
    } }, directives: [ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective, ɵngcc2.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵNgSelectMultipleOption], styles: [_c11] });
WrapperSelectComponent.ctorParameters = () => [
    { type: FormlyDesignerConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrapperSelectComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-wrapper-select',
                template: `
    <select [formControl]="formControl" class="custom-select">
      <option *ngFor="let wrapper of wrappers" [ngValue]="wrapper">{{ wrapper }}</option>
    </select>
  `,
                providers: [WRAPPER_SELECT_CONTROL_VALUE_ACCESSOR],
                styles: [`
    select {
      width: 100%;
    }
  `]
            }]
    }], function () { return [{ type: FormlyDesignerConfig }]; }, null); })();

class WrappersPickerComponent {
    constructor(formlyDesignerConfig, formlyDesignerService) {
        this.formlyDesignerConfig = formlyDesignerConfig;
        this.formlyDesignerService = formlyDesignerService;
        this.selected = new EventEmitter();
        this.wrapper = null;
        this.fieldEdit = new FormControl({});
        this.wrappers = [];
    }
    ngOnChanges(changes) {
        if (changes.field) {
            this.wrappers = this.formlyDesignerService.getWrappers(changes.field.currentValue);
        }
    }
    get $modal() {
        var _a;
        return $((_a = this.modalRef) === null || _a === void 0 ? void 0 : _a.nativeElement);
    }
    onWrapperSelected(field) {
        this.selected.emit(field);
    }
    edit(index) {
        this.wrapper = this.wrappers[index];
        if (isObject(this.field)) {
            const field = cloneDeep(this.field);
            if (isArray(field === null || field === void 0 ? void 0 : field.wrappers)) {
                this.fieldEdit.setValue(field);
                const fields = this.formlyDesignerConfig.wrappers[this.wrapper].fields;
                if (isArray(fields) && fields.length > 0) {
                    this.$modal.modal('show');
                }
                else {
                    this.onApply();
                }
            }
        }
    }
    remove(index) {
        var _a, _b, _c;
        const fieldWrappersIndex = (_c = (_b = (_a = this.field) === null || _a === void 0 ? void 0 : _a.wrappers) === null || _b === void 0 ? void 0 : _b.indexOf(this.wrappers[index])) !== null && _c !== void 0 ? _c : -1;
        if (fieldWrappersIndex < 0) {
            return;
        }
        const field = cloneDeep(this.field);
        field.wrappers.splice(fieldWrappersIndex, 1);
        this.field = this.formlyDesignerService.createPrunedField(field);
        this.selected.emit(this.field);
    }
    onApply() {
        this.field = this.formlyDesignerService.createPrunedField(this.fieldEdit.value);
        this.selected.emit(this.field);
        this.$modal.modal('hide');
    }
}
WrappersPickerComponent.ɵfac = function WrappersPickerComponent_Factory(t) { return new (t || WrappersPickerComponent)(ɵngcc0.ɵɵdirectiveInject(FormlyDesignerConfig), ɵngcc0.ɵɵdirectiveInject(FormlyDesignerService)); };
WrappersPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WrappersPickerComponent, selectors: [["formly-designer-wrappers-picker"]], viewQuery: function WrappersPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalRef = _t.first);
    } }, inputs: { field: "field" }, outputs: { selected: "selected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 22, vars: 6, consts: [[1, "form-group"], [1, "input-group"], [3, "field", "selected"], ["class", "badge badge-default noselect", 3, "click", 4, "ngFor", "ngForOf"], ["tabindex", "-1", "role", "dialog", 1, "modal", "fade"], ["modal", ""], ["role", "document", 1, "modal-dialog", "modal-lg"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Cancel", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], [3, "formControl", "wrapper"], ["editor", ""], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "badge", "badge-default", "noselect", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-times", 3, "click"]], template: function WrappersPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "formly-designer-wrapper-picker", 2);
        ɵngcc0.ɵɵlistener("selected", function WrappersPickerComponent_Template_formly_designer_wrapper_picker_selected_2_listener($event) { return ctx.onWrapperSelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, WrappersPickerComponent_div_3_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4, 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵelementStart(9, "h5", 9);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 10);
        ɵngcc0.ɵɵelementStart(12, "span", 11);
        ɵngcc0.ɵɵtext(13, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵelement(15, "formly-designer-wrapper-editor", 13, 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 15);
        ɵngcc0.ɵɵelementStart(18, "button", 16);
        ɵngcc0.ɵɵtext(19, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "button", 17);
        ɵngcc0.ɵɵlistener("click", function WrappersPickerComponent_Template_button_click_20_listener() { return ctx.onApply(); });
        ɵngcc0.ɵɵtext(21, "Apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(16);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.field);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.wrappers);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1("Edit ", ctx.wrapper, "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formControl", ctx.fieldEdit)("wrapper", ctx.wrapper);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", _r2.invalid);
    } }, directives: [WrapperPickerComponent, ɵngcc2.NgForOf, WrapperEditorComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective], styles: [".badge[_ngcontent-%COMP%] {\n      margin-right: .25em;\n    }\n    .badge[_ngcontent-%COMP%] {\n      cursor: pointer;\n    }\n    .noselect[_ngcontent-%COMP%] {\n      -webkit-user-select: none;\n      -khtml-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n    }"] });
WrappersPickerComponent.ctorParameters = () => [
    { type: FormlyDesignerConfig },
    { type: FormlyDesignerService }
];
WrappersPickerComponent.propDecorators = {
    modalRef: [{ type: ViewChild, args: ['modal', { static: true },] }],
    field: [{ type: Input }],
    selected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrappersPickerComponent, [{
        type: Component,
        args: [{
                selector: 'formly-designer-wrappers-picker',
                template: `
    <div class="form-group">
      <div class="input-group">
        <formly-designer-wrapper-picker [field]="field" (selected)="onWrapperSelected($event)">
        </formly-designer-wrapper-picker>
      </div>
      <div *ngFor="let wrapper of wrappers; let i = index" class="badge badge-default noselect" (click)="edit(i)">
        {{ wrapper }}&nbsp;&nbsp;<i class="fa fa-times" aria-hidden="true" (click)="remove(i)"></i>
      </div>
    </div>
    <div #modal class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit {{ wrapper }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <formly-designer-wrapper-editor #editor [formControl]="fieldEdit" [wrapper]="wrapper">
            </formly-designer-wrapper-editor>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="onApply()"
              [disabled]="editor.invalid">Apply</button>
          </div>
        </div>
      </div>
    </div>
    `,
                styles: [`
    .badge {
      margin-right: .25em;
    }
    .badge {
      cursor: pointer;
    }
    .noselect {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  `]
            }]
    }], function () { return [{ type: FormlyDesignerConfig }, { type: FormlyDesignerService }]; }, { selected: [{
            type: Output
        }], field: [{
            type: Input
        }], modalRef: [{
            type: ViewChild,
            args: ['modal', { static: true }]
        }] }); })();

function decycle(value) {
    if (value == null) {
        return value;
    }
    let nextId = 1;
    const objects = new Map();
    return traverse(cloneDeep(value), (_key, v) => {
        if (isObject(v)) {
            if (objects.has(v)) {
                let id = objects.get(v);
                if (!id) {
                    v.$id = id = nextId++;
                    objects.set(v, id);
                }
                return { $ref: id };
            }
            else {
                objects.set(v, 0);
            }
        }
        return;
    });
}
function traverse(obj, replace) {
    if (isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
            traverseValue.bind(obj, i, obj[i], replace)();
        }
    }
    else if (isObject(obj)) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                traverseValue.bind(obj, key, obj[key], replace)();
            }
        }
    }
    return obj;
}
function traverseValue(key, value, replace) {
    const replacement = replace(key, value);
    if (replacement === undefined) {
        traverse(value, replace);
    }
    else if (this) {
        this[key] = replacement;
    }
}

class DecyclePipe {
    transform(value) {
        return decycle(value);
    }
}
DecyclePipe.ɵfac = function DecyclePipe_Factory(t) { return new (t || DecyclePipe)(); };
DecyclePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "decycle", type: DecyclePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DecyclePipe, [{
        type: Pipe,
        args: [{ name: 'decycle' }]
    }], null, null); })();

class FormlyDesignerModule {
    constructor(config, formlyConfig) {
        formlyConfig.addConfig(config);
    }
    static forRoot(designerConfig = {}) {
        return {
            ngModule: FormlyDesignerModule,
            providers: [
                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: [fieldComponents, wrapperComponents], multi: true },
                { provide: FORMLY_DESIGNER_CONFIG_TOKEN, useValue: designerConfig, multi: true }
            ]
        };
    }
}
FormlyDesignerModule.ɵfac = function FormlyDesignerModule_Factory(t) { return new (t || FormlyDesignerModule)(ɵngcc0.ɵɵinject(Config), ɵngcc0.ɵɵinject(ɵngcc1.FormlyConfig)); };
FormlyDesignerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormlyDesignerModule });
FormlyDesignerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        Config,
        DesignerExtension,
        DragDropService,
        FormlyDesignerConfig,
        FieldsService
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild()
        ]] });
FormlyDesignerModule.ctorParameters = () => [
    { type: Config },
    { type: FormlyConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyDesignerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FieldEditorComponent,
                    FieldPickerComponent,
                    FormlyDesignerComponent,
                    PropertiesComponent,
                    TypesComponent,
                    TypeSelectComponent,
                    WrapperEditorComponent,
                    WrapperSelectComponent,
                    WrapperPickerComponent,
                    WrappersPickerComponent,
                    DecyclePipe,
                    fieldComponents,
                    wrapperComponents
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    FormlyModule.forChild()
                ],
                exports: [
                    FieldEditorComponent,
                    FormlyDesignerComponent,
                    PropertiesComponent,
                    TypesComponent,
                    WrapperEditorComponent
                ],
                providers: [
                    Config,
                    DesignerExtension,
                    DragDropService,
                    FormlyDesignerConfig,
                    FieldsService
                ],
                entryComponents: [FormlyForm]
            }]
    }], function () { return [{ type: Config }, { type: ɵngcc1.FormlyConfig }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyDesignerModule, { declarations: function () { return [FieldEditorComponent, FieldPickerComponent, FormlyDesignerComponent, PropertiesComponent, TypesComponent, TypeSelectComponent, WrapperEditorComponent, WrapperSelectComponent, WrapperPickerComponent, WrappersPickerComponent, DecyclePipe, FormlyDesignerWrapperComponent, FormlyDesignerFieldWrapperComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule, ɵngcc1.FormlyModule]; }, exports: function () { return [FieldEditorComponent, FormlyDesignerComponent, PropertiesComponent, TypesComponent, WrapperEditorComponent]; } }); })();

/*
 * Public API Surface of ngx-formly-designer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Config, DESIGNER_WRAPPER_NAME, DESIGNER_WRAPPER_TYPES, FIELD_DESIGNER_WRAPPER_NAME, FORMLY_DESIGNER_CONFIG_TOKEN, FieldType, FieldsService, FormlyDesignerComponent, FormlyDesignerConfig, FormlyDesignerModule, FormlyDesignerService, decycle, fieldComponents, wrapperComponents, FormlyDesignerWrapperComponent as ɵa, FormlyDesignerFieldWrapperComponent as ɵb, ParentService as ɵc, DragDropService as ɵd, FieldsService as ɵe, FormlyDesignerService as ɵf, DesignerExtension as ɵg, FieldEditorComponent as ɵh, FieldsService as ɵi, FormlyDesignerConfig as ɵj, FieldPickerComponent as ɵk, PropertiesComponent as ɵl, FormlyDesignerConfig as ɵm, TypesComponent as ɵn, TypeSelectComponent as ɵo, WrapperEditorComponent as ɵp, WrapperSelectComponent as ɵq, WrapperPickerComponent as ɵr, WrappersPickerComponent as ɵs, DecyclePipe as ɵt, DragDropService as ɵu };

